/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from "react";
import { Link } from "react-router-dom";
import Modal from "../Modal/Modal";
import withData from "../../highOrderComponents/withData";
import {
  clearPlacedOrder,
  placeOrder,
} from "../../state/actions/placeOrderAction";
import { RootState } from "../../state/store/store";
import { OrderAttributes } from "../../state/types/orderTypes";
import { routes } from "../../app-constants";

interface ITransitionValidatorProps {
  allowRedirect: (index: number, allow: boolean) => void;
  index: number;
  dispatchAction?: Function;
  store?: RootState;
}

interface ITransitionValidatorState {
  errorMessage: string | null;
}

class TransitionValidator extends React.Component<
  ITransitionValidatorProps,
  ITransitionValidatorState
> {
  isDataUpToDate = false;

  constructor(props: ITransitionValidatorProps) {
    super(props);
    this.resetValidator();
    this.state = { errorMessage: null };
  }

  get vendorId(): number {
    try {
      return (
        this.props.store?.selectedVendor.data.id ||
        Number.parseInt(process.env.REACT_APP_VENDOR_ID || "0")
      );
    } catch (error) {
      console.error(
        "The REACT_APP_VENDOR_ID should be defined or a vendor should be selected"
      );
      return 0;
    }
  }

  resetValidator() {
    this.isDataUpToDate = false;
  }

  componentDidMount() {
    // @ts-ignore - Project Upgrade
    const menuId = this.props.store?.menu.menuByVendor[this.vendorId].id;

    // Fetch URL query parameters
    const searchParams = new URLSearchParams(window.location.search);

    const attributes: OrderAttributes = searchParams.has("campaignId")
      ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        { patron: { campaignId: searchParams.get("campaignId")! } }
      : {};

    // @ts-ignore - Project Upgrade
    this.props.dispatchAction(
      // @ts-ignore - Project Upgrade
      placeOrder(this.props.store.order, this.vendorId, menuId, attributes)
    );
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps: ITransitionValidatorProps) {
    this.isDataUpToDate =
      this.isDataUpToDate ||
      (this.props.store?.placedOrder.fetchStatus === "fetching" &&
        nextProps.store?.placedOrder.fetchStatus === "success");
  }

  componentDidUpdate() {
    if (this.props.store?.placedOrder.fetchStatus === "failed") {
      if (!this.state.errorMessage) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const error = this.props.store?.placedOrder.error as any;
        const message =
          error?.response?.data?.messages?.[0]?.message ||
          "Failed to place order. Please go back and try again.";
        // @ts-ignore - Project Upgrade
        this.props.dispatchAction?.(clearPlacedOrder());
        this.setState({ errorMessage: message });
      }
    } else if (this.isDataUpToDate) {
      this.props.allowRedirect(this.props.index, true);
    }
  }

  render() {
    const { errorMessage } = this.state;
    if (!errorMessage) {
      return null;
    }
    return (
      <Modal
        className="alert-modal"
        isOpen={true}
        title="Unable to place order"
        content={<p className="alert-modal-text">{errorMessage}</p>}
        actions={
          <Link
            className="btn btn-primary"
            to={routes.ORDER_FLOW.CONFIRM_ORDER.PATH}
            onClick={() => this.setState({ errorMessage: null })}
          >
            Go back
          </Link>
        }
      />
    );
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default withData()(TransitionValidator) as any;
